module.exports = __webpack_public_path__ + "img/icon_employees.71f81d97.png";